/**
 * Тап вместо hover для .touch-hover.
 * Повторяет старую логику: меняем класс _hv и шлём mouseenter/mouseleave.
 */
function touchHover(root = document.body) {
    // На случай отсутствия функции (например в тестах)
    if (!matchMedia)
        return;
    const supportsHover = matchMedia('(hover: hover)').matches;
    const isFinePointer = matchMedia('(pointer: fine)').matches;
    // На десктопах с реальным hover ничего не делаем
    if (supportsHover && isFinePointer)
        return;
    const items = root.querySelectorAll('.touch-hover');
    const fire = (el, type) => {
        // Нативный MouseEvent вместо jQuery.trigger
        const evt = new MouseEvent(type, { bubbles: false, cancelable: true, view: window });
        el.dispatchEvent(evt);
    };
    for (const el of Array.from(items)) {
        if (el.dataset.inited === '1')
            continue;
        el.dataset.inited = '1';
        const onTap = (e) => {
            // Интересуют тач/перо; мышь нам не нужна
            if (e.pointerType && e.pointerType !== 'touch' && e.pointerType !== 'pen')
                return;
            const active = el.classList.toggle('_hv');
            fire(el, active ? 'mouseenter' : 'mouseleave');
            e.preventDefault();
        };
        el.addEventListener('pointerup', onTap);
        // В вашем виджете сохраните ссылку и снимите обработчик в _onDestroy:
        // const _off = () => el.removeEventListener('pointerup', onTap);
    }
}

export { touchHover };
